import './Styles.scss'

let pollsL10n = window.pollsL10n || {}

pollsL10n = {
    'ajax_url':      window.ajaxURL,
    'text_wait':     'Vaše poslední hlasování se stále zpracovává. Zkuste to prosím znovu za chvíli...',
    'text_valid':    'Prosím zvolte validní odpověď.',
    'text_multiple': 'Maximální povolený počet odpovědí: '
}

function ajax(args) {
    let XMLHttp = new XMLHttpRequest()

    XMLHttp.onreadystatechange = () => {
        XMLHttp.onreadystatechange = () => {
            if (XMLHttp.readyState === XMLHttpRequest.DONE && XMLHttp.status === 200) {
                args.success(XMLHttp.responseText)

                fixLinksEvents()
            }
        }
    }

    XMLHttp.withCredentials = true

    XMLHttp.open('POST', window.ajaxURL, true)

    XMLHttp.setRequestHeader('Cache-Control', 'no-cache, no-store, must-revalidate')
    XMLHttp.setRequestHeader('Pragma', 'no-cache')
    XMLHttp.setRequestHeader('Expires', '0')

    XMLHttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
    XMLHttp.send(args.data)
}

// When User Vote For Poll
export function poll_vote(current_poll_id) {
    let poll_answer_id = ''
    let poll_multiple_ans = 0
    let poll_multiple_ans_count = 0

    if (document.getElementById('poll_multiple_ans_' + current_poll_id)) {
        poll_multiple_ans = parseInt(document.getElementById('poll_multiple_ans_' + current_poll_id).value);
    }

    const options = document.querySelectorAll('#polls_form_' + current_poll_id + ' input[type="checkbox"], #polls_form_' + current_poll_id + ' input[type="radio"], #polls_form_' + current_poll_id + ' option')

    options.forEach((option) => {
        if (option.checked) { // Todo: support for selectbox option
            if (poll_multiple_ans > 0) {
                poll_answer_id = option.value + ',' + poll_answer_id;
                poll_multiple_ans_count++;
            } else {
                poll_answer_id = parseInt(option.value);
            }
        }
    })

    if (poll_multiple_ans > 0) {
        if (poll_multiple_ans_count > 0 && poll_multiple_ans_count <= poll_multiple_ans) {
            poll_answer_id = poll_answer_id.substring(0, (poll_answer_id.length - 1))
            poll_process(current_poll_id, poll_answer_id)
        } else if (poll_multiple_ans_count === 0) {
            alert(pollsL10n.text_valid)
        } else {
            alert(pollsL10n.text_multiple + ' ' + poll_multiple_ans)
        }
    } else {
        if (poll_answer_id > 0) {
            poll_process(current_poll_id, poll_answer_id)
        } else {
            alert(pollsL10n.text_valid)
        }
    }
}

// Process Poll (User Click "Vote" Button)
function poll_process(current_poll_id, poll_answer_id) {
    const poll_nonce = document.getElementById('poll_' + current_poll_id + '_nonce').value

    document.getElementById('polls-' + current_poll_id).style.opacity = '0'
    document.getElementById('polls-' + current_poll_id + '-loading').style.display = 'block'

    ajax({
        data:    'action=polls&view=process&poll_id=' + current_poll_id + '&poll_' + current_poll_id + '=' + poll_answer_id + '&poll_' + current_poll_id + '_nonce=' + poll_nonce,
        success: poll_process_success(current_poll_id)
    })
}

// Poll's Result (User Click "View Results" Link)
export function poll_result(current_poll_id) {
    const poll_nonce = document.getElementById('poll_' + current_poll_id + '_nonce').value

    document.getElementById('polls-' + current_poll_id).style.opacity = '0'
    document.getElementById('polls-' + current_poll_id + '-loading').style.display = 'block'

    ajax({
        data:    'action=polls&view=result&poll_id=' + current_poll_id + '&poll_' + current_poll_id + '_nonce=' + poll_nonce,
        success: poll_process_success(current_poll_id)
    })
}

// Poll's Voting Booth  (User Click "Vote" Link)
export function poll_booth(current_poll_id) {
    const poll_nonce = document.getElementById('poll_' + current_poll_id + '_nonce').value

    document.getElementById('polls-' + current_poll_id + '-loading').style.display = 'block'

    ajax({
        data:    'action=polls&view=booth&poll_id=' + current_poll_id + '&poll_' + current_poll_id + '_nonce=' + poll_nonce,
        success: poll_process_success(current_poll_id)
    })
}

// Poll Process Successfully
function poll_process_success(current_poll_id) {
    return function (data) {
        const node = new DOMParser().parseFromString(data, 'text/html').body.childNodes[0]

        document.getElementById('polls-' + current_poll_id).replaceWith(node)
        document.getElementById('polls-' + current_poll_id + '-loading').style.display = 'none'
    }
}

// Fix links events
const fixLinksEvents = () => {
    // View results
    let links = document.querySelectorAll('[href="#ViewPollResults"]')

    links.forEach((link) => {
        const poll = link.closest('.wp-polls')
        const id = parseInt(poll.getAttribute('id').replace('polls-', ''))

        link.setAttribute('onclick', 'window.common.poll_result(' + id + '); return false;')
    })

    // View poll
    links = document.querySelectorAll('[href="#VotePoll"]')

    links.forEach((link) => {
        const poll = link.closest('.wp-polls')
        const id = parseInt(poll.getAttribute('id').replace('polls-', ''))

        link.setAttribute('onclick', 'window.common.poll_booth(' + id + '); return false;')
    })

    // Vote poll
    links = document.querySelectorAll('.wp-polls-form input[name="vote"]')

    links.forEach((link) => {
        const poll = link.closest('.wp-polls')
        const id = parseInt(poll.getAttribute('id').replace('polls-', ''))

        link.setAttribute('onclick', 'window.common.poll_vote(' + id + ')')
    })
}

document.addEventListener('DOMContentLoaded', function (event) {
    fixLinksEvents()
})